// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"ViewClients_cardTitle__I2MTy","actions":"ViewClients_actions__1kTEF"};